<ng-container>

  <main class="container-fluid">
    <div class="row row-eq-height">
      <section class="col-8">
        <div class="lesson-content">
          <div class="problem-content sticky-top">
            <app-content-viewer [content]="strategyProblem.content"></app-content-viewer>
          </div>

          <div class="problem-passage">
            @if (strategyProblem.passage) {
              <app-content-viewer [content]="strategyProblem.passage.content"></app-content-viewer>
            }
          </div>
        </div>

        <div class="lesson-footer">
          <div class="lesson-goals">
            <div class="row">
              <div class="col-1 text-right">
                <i class="fa fa-bullseye"></i>
              </div>

              <div class="col-4">
                <div class="progress">
                  <div class="progress-bar progress-bar-striped" role="progressbar"
                    style="height: 1.5rem; line-height: 1.5rem" aria-valuenow="20" aria-valuemin="0"
                    [style.width.%]="75"
                    aria-valuemax="100">75%
                  </div>
                </div>
              </div>

              <div class="col-2 text-right">
                <i class="fa fa-stopwatch"></i> ##s
              </div>

              <div class="col-4">
                <div class="progress">
                  <div class="w-50">
                    <div class="progress-bar progress-bar-striped bg-primary progress-bar-fast" role="progressbar"
                      [style.width.%]="25"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="50">
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="progress-bar progress-bar-striped bg-danger progress-bar-slow" role="progressbar"
                      [style.width.%]="0"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="50">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <aside class="col-4">
        <div class="lesson-answers">
          <app-multi-choice [options]="strategyTopics"
            [displayField]="'strategyName'"
            [idField]="'id'"
            (optionSelected)="handleSelectedTopic()">
          </app-multi-choice>

          @if (readyToContinue) {
            <button class="btn btn-primary" [routerLink]="['../hypothesis']" ngbTooltip="Next">
              Next
            </button>
          }
        </div>
      </aside>
    </div>
  </main>

  <!--<app-lesson-help></app-lesson-help>-->
</ng-container>

<!--<ng-template #loading>-->
<!--<app-spinner></app-spinner>-->
<!--</ng-template>-->
